import { Menu, MenuItem } from '@mui/material';
import React from 'react';

interface ActionMenusProps {
  reviewMenuAnchor: HTMLElement | null;
  onReviewMenuClose: () => void;
  onReviewAction: (action: string) => void;
  callRequestMenuAnchor: HTMLElement | null;
  onCallRequestMenuClose: () => void;
  onCallRequestAction: (action: string) => void;
  isOwnProfile?: boolean;
  selectedRequestStatus?: string;
}

const menuPaperStyles = {
  borderRadius: 2,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  minWidth: 180,
  mt: 1,
};

const menuItemStyles = {
  py: 1.5,
  px: 2,
  fontSize: '0.9375rem',
  '&:hover': {
    backgroundColor: 'rgba(120, 187, 241, 0.14)',
  },
};

export const ActionMenus: React.FC<ActionMenusProps> = ({
  reviewMenuAnchor,
  onReviewMenuClose,
  onReviewAction,
  callRequestMenuAnchor,
  onCallRequestMenuClose,
  onCallRequestAction,
  isOwnProfile = false,
  selectedRequestStatus,
}) => {
  // Check if the request can be accepted/declined (only pending or active requests)
  const canAcceptOrDecline = selectedRequestStatus === 'pending' || selectedRequestStatus === 'active';
  // Check if the request can be cancelled (only pending or active requests)
  const canCancel = selectedRequestStatus === 'pending' || selectedRequestStatus === 'active';
  return (
    <>
      <Menu
        anchorEl={reviewMenuAnchor}
        open={Boolean(reviewMenuAnchor)}
        onClose={onReviewMenuClose}
        slotProps={{
          paper: { sx: menuPaperStyles },
        }}
      >
        <MenuItem onClick={() => onReviewAction('read')} sx={menuItemStyles}>
          Read Review
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={callRequestMenuAnchor}
        open={Boolean(callRequestMenuAnchor)}
        onClose={onCallRequestMenuClose}
        slotProps={{
          paper: {
            sx: {
              ...menuPaperStyles,
              minWidth: 160,
            },
          },
        }}
      >
        <MenuItem onClick={() => onCallRequestAction('view')} sx={menuItemStyles}>
          View Details
        </MenuItem>
        {isOwnProfile
          ? canAcceptOrDecline && (
              <>
                <MenuItem
                  onClick={() => onCallRequestAction('accept')}
                  sx={{
                    ...menuItemStyles,
                    color: 'success.main',
                    '&:hover': {
                      backgroundColor: 'rgba(46, 125, 50, 0.08)',
                    },
                  }}
                >
                  Accept Consultation
                </MenuItem>
                <MenuItem
                  onClick={() => onCallRequestAction('decline')}
                  sx={{
                    ...menuItemStyles,
                    color: 'error.main',
                    '&:hover': {
                      backgroundColor: 'rgba(211, 47, 47, 0.08)',
                    },
                  }}
                >
                  Decline Consultation
                </MenuItem>
              </>
            )
          : canCancel && (
              <MenuItem
                onClick={() => onCallRequestAction('cancel')}
                sx={{
                  ...menuItemStyles,
                  color: 'error.main',
                  '&:hover': {
                    backgroundColor: 'rgba(211, 47, 47, 0.08)',
                  },
                }}
              >
                Cancel Request
              </MenuItem>
            )}
      </Menu>
    </>
  );
};
